module.exports = __webpack_public_path__ + "img/048.a0ed98c1.png";